// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"baec72ed","342":"b7006f8c","474":"c93c2175","678":"79f77fc3","783":"3f628f67"}[chunkId] + ".chunk.js";
};